import React from 'react';
import { twMerge } from 'tailwind-merge';

type HorizontalLineProps = {
  className?: string;
};

export const HorizontalLine = (props: HorizontalLineProps) => {
  const { className } = props;
  return (
    <div className={twMerge('w-full border-b border-[#808080]', className)} />
  );
};
